import React, { Component } from "react";
import "../style/model.scss";
import HeadBar from "./common/HeadBar";
import i5M60 from "../image/bmw-i5-m60.png";
import ixM60 from "../image/bmw-ix-m60.png";
import i4 from "../image/bmw-i4.png";
import bmw3 from "../image/bmw3.png";
import {
  submitFBConversionEvent,
  submitGGconversionEvent,
} from "../apis/FacebookAPI";
import * as CountPixelEventAPI from "../apis/CountPixelEventAPI";
import * as PostMessageAPI from "../apis/PostMessageAPI";
import { routePage } from "../utils/routePage";
import { BASE_URL } from "../constants/ApiEndpointConstants";
import color1 from "../image/color1.png";
import color2 from "../image/color2.png";
import color3 from "../image/color3.png";
import i5M60_black from "../image/i5M60-Black.png";
import i5M60_Blue from "../image/i5M60-Blue.png";
import i5M60_Gray from "../image/i5M60-Gray.png";
import Series_Black from "../image/3Series-Black.png";
import Series_Blue from "../image/3Series-Blue.png";
import Series_Gray from "../image/3Series-Gray.png";
import { generateEventId } from "../utils/RandomGeneratorUtils.js";
import {
  DEFAULT_CONTENTS_TITLE,
  DEFAULT_CONTENTS_TITLE_2,
  DEFAULT_CONTENT_IDS,
  DEFAULT_CONTENT_TYPE,
} from "../constants/ApiEndpointConstants.js";
import safeParse from "../utils/SafeParseLocalstrorage";
import { lang, t } from "../utils/lang.js";
import getAd from "../utils/GetAd";
import Model_3 from "../image/model-3.jpg";
import Model_Y from "../image/model-y.jpg";
import PagePath from "../constants/router/PagePath";
import { tiktokTrack } from "../apis/TikTokAPI.js";

class Model extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cartList: [
        {
          id: 1,
          title: "Cybertruck",
          choose: false,
          img: null,
          disabled: true,
        },
        {
          id: 2,
          title: "Model 3",
          choose: true,
          img: Model_3,
          disabled: false,
        },
        {
          id: 3,
          title: "Model X",
          choose: false,
          img: null,
          disabled: true,
        },
        {
          id: 4,
          title: "Model Y",
          choose: false,
          img: Model_Y,
          disabled: false,
        },
      ],

      vehicleModel: {
        id: 2,
        title: "Model 3",
        choose: true,
        img: Model_3,
        disabled: false,
      },
      colorIndex: 0,
      pixel: safeParse("pixel"),
      fbqToken: safeParse("fbqToken"),
      ad: getAd(),
      tgid: safeParse("tgid"),
      orderDetail: safeParse("orderDetail") || {},
      groupid: safeParse("groupid"),
      rendomNum: 0,
    };
    this.changeSelect = this.changeSelect.bind(this);
    this.routeCustomer = this.routeCustomer.bind(this);
    this.getRendomNum = this.getRendomNum.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    this.viewContent();
    this.getRendomNum();
  }

  changeSelect(id) {
    let { cartList, pixel, fbqToken, ad, vehicleModel, groupid } = this.state;
    let selected = cartList.find((item) => item.id === id);
    if (!selected || selected.disabled) return;
    if (selected) {
      this.getRendomNum();
      this.setState(
        {
          vehicleModel: {
            id: selected.id,
            title: selected.title,
            img: selected.img,
          },
          colorIndex: 0,
        },
        () => {
          const eventId = generateEventId(
            "CustomizeProduct",
            selected.price || "69.9",
          );
          const eventParams = { selectedSku: selected.price || "69.9" };
          submitFBConversionEvent(
            "CustomizeProduct",
            eventParams,
            null,
            eventId,
            null,
          );
          CountPixelEventAPI.countPixelEvent("CustomizeProduct", eventId);
          // tiktok
          const tiktokEventParams = {
            content_type: "product",
            content_ids: [String(vehicleModel?.id || "")],
            contents: [
              {
                content_id: String(vehicleModel?.id || ""),
                content_name: `${vehicleModel.title} ${vehicleModel?.id}`,
                quantity: 1,
                price: 9.9,
              },
            ],
            currency: "USD",
            value: 9.9,
          };

          tiktokTrack("CustomizeProduct", tiktokEventParams, eventId);
        },
      );
    }
  }

  routeCustomer() {
    let { history, location } = this.props;
    let { vehicleModel, orderDetail, tgid, pixel, fbqToken, ad } = this.state;
    orderDetail.vehicleModel = vehicleModel?.title || "";
    orderDetail.tgid = tgid;
    orderDetail.pixel = pixel;
    orderDetail.fbqToken = fbqToken;
    orderDetail.ad = ad;
    localStorage.setItem("orderDetail", JSON.stringify(orderDetail));
    routePage(history, ad, PagePath.CUSTOMER);
  }

  getRendomNum() {
    let number = Math.floor(Math.random() * 100) + 101;
    this.setState({ rendomNum: number });
  }

  viewContent() {
    const { groupid, vehicleModel } = this.state;
    const eventId = generateEventId("ViewContent", DEFAULT_CONTENT_IDS[0]);
    const eventParams = {
      value: 9.9,
    };

    submitFBConversionEvent(
      "ViewContent",
      eventParams,
      null,
      eventId,
      null,
    ).then((res) => {});
    CountPixelEventAPI.countPixelEvent("ViewContent", eventId);
    // Google
    submitGGconversionEvent("view_item", {
      currency: "USD",
      items: [
        {
          item_id: String(vehicleModel?.id) || "",
          item_name: `${vehicleModel.title} ${vehicleModel?.id}`,
          item_category: "driver_car",
        },
      ],
    });
    // tiktok
    const tiktokEventParams = {
      content_type: "product",
      content_ids: [String(vehicleModel?.id || "")],
      contents: [
        {
          content_id: String(vehicleModel?.id || ""),
          content_name: `${vehicleModel.title} ${vehicleModel?.id}`,
          quantity: 1,
          price: 9.9,
        },
      ],
      currency: "USD",
      value: 9.9,
    };

    tiktokTrack("ViewContent", tiktokEventParams, eventId);
  }

  render() {
    const { cartList, vehicleModel, rendomNum, colorList, colorIndex } =
      this.state;
    return (
      <React.Fragment>
        <div className="model-page">
          <HeadBar {...this.props} />
          <div className="model-box">
            <div className="font-[400] text-2xl">{lang.demoTitle}</div>
            <div className="detail">{lang.demoDescription}</div>
            <div className="font-[450] mt-2  text-sm">
              {vehicleModel.title} ({t("trialToday", { count: rendomNum })})
            </div>

            <div className="choose-box grid grid-cols-1 md:grid-cols-3 gap-4">
              <div className="left ">
                {cartList.map((item, index) => {
                  return (
                    <div
                      className={item.disabled ? "disabled" : ""}
                      key={index}
                    >
                      <li
                        className={
                          parseInt(item.id) === parseInt(vehicleModel.id)
                            ? "active"
                            : ""
                        }
                        onClick={() => this.changeSelect(item.id)}
                      >
                        {item.title}
                      </li>
                    </div>
                  );
                })}
              </div>
              <div className="right col-span-2">
                <img
                  src={this.state.vehicleModel.img}
                  alt={this.state.vehicleModel.title}
                />
              </div>
            </div>
            <div className="btn" onClick={this.routeCustomer}>
              {lang.next}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Model;
